<template>
    <ul class="list">
        <slot />
    </ul>
</template>

<script>
import { ContainerMixin } from 'vue-slicksort';

export default {
    mixins: [ContainerMixin],
};
</script>

<style scoped lang="less">
@import "~styles/const.less";

ul {
    padding: 0;
    margin: 0;
}
</style>